import authHook from './routerAuthHook'
import bodyClassHook from './bodyClassHook'
import { Store } from 'vuex'
import { VueRouter } from 'vue-router/types/router'

export default (store: Store<any>, router: VueRouter) => {
  router.beforeEach(authHook(store))
  router.beforeEach(bodyClassHook())
}
